import { render } from "./LayoutEmpty.vue?vue&type=template&id=217afbb1&ts=true"
import script from "./LayoutEmpty.vue?vue&type=script&lang=ts"
export * from "./LayoutEmpty.vue?vue&type=script&lang=ts"

import "./LayoutEmpty.vue?vue&type=style&index=0&id=217afbb1&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QPageContainer});
